module.exports = __webpack_public_path__ + "img/hacienda-resort-6.ca8165bc.jpg";